import { Model, ModelAttributes, model, modelConfig } from "@mixitone/oom";
import AccountUser from "./AccountUser";
import { setAccountId } from "./concerns/SetAccountId";

const config = modelConfig(
  {
    account_id: {
      type: "string",
    },
    created_at: {
      type: "datetime",
    },
    is_deleted: {
      type: "boolean",
    },
    tournament_signup: {
      type: "boolean",
    },
    updated_at: {
      type: "datetime",
    },
    user_id: {
      type: "string",
    },
  },
  {},
  {},
);

interface UserNotificationPreference extends ModelAttributes<typeof config> {}

export const USER_NOTIFICATION_TYPES = [
  {
    key: "tournament_signup" as const,
    label: "Tournament signups",
    description: "Email me when a player registers for a tournament at one of this account's clubs.",
    defaultValue: true,
  },
] as const;

export type UserNotificationTypeKey = (typeof USER_NOTIFICATION_TYPES)[number]["key"];

@setAccountId
@model("user_notification_preferences", config)
class UserNotificationPreference extends Model<typeof config> {
  static async findOrCreateForCurrentUser(): Promise<UserNotificationPreference> {
    const accountUser = AccountUser.current;
    if (!accountUser?.account_id || !accountUser.user_id) {
      throw new Error("No current user");
    }

    const existing = await UserNotificationPreference.query()
      .eq("account_id", accountUser.account_id)
      .eq("user_id", accountUser.user_id)
      .eq("is_deleted", false)
      .first();

    if (existing) return existing;

    return new UserNotificationPreference({
      account_id: accountUser.account_id,
      user_id: accountUser.user_id,
      tournament_signup: true,
    });
  }

  override canDestroy() {
    return false;
  }
}

export default UserNotificationPreference;
